import { render, staticRenderFns } from "./PostingList.vue?vue&type=template&id=bd35d9f6&scoped=true&"
import script from "./PostingList.vue?vue&type=script&lang=js&"
export * from "./PostingList.vue?vue&type=script&lang=js&"
import style0 from "./PostingList.vue?vue&type=style&index=0&id=bd35d9f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd35d9f6",
  null
  
)

export default component.exports